import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface ActionsTitleProps {
    selectedRows: any[];
    title: string;
}

export const ActionsTitle: React.FC<ActionsTitleProps> = ({selectedRows, title}) => {
    return (
        <>
            <Box>
                <Typography variant="h6">{title}</Typography>
            </Box>
            <Box>
                <Typography variant="body2">
                    {selectedRows.length === 1
                        ? 'You have selected 1 item.'
                        : `You have selected ${selectedRows.length} items.`}
                </Typography>
            </Box>
        </>
    );
};

export default ActionsTitle;
